var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12.729px",
    height: "12.727px",
    viewBox: "80.176 173.695 12.729 12.727",
    enableBackground: "new 80.176 173.695 12.729 12.727",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2d8245",
    points: "92.905,175.109 91.49,173.695 86.54,178.644  81.59,173.695 80.176,175.109 85.126,180.058 80.176,185.008 81.59,186.422 86.54,181.472 91.49,186.422 92.905,185.008  87.955,180.058  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose01);
export default __webpack_public_path__ + "static/media/close-01.aef001592fd86bde02e38ec076213a5c.svg";
export { ForwardRef as ReactComponent };